import request from 'superagent';
import * as fakeApi from './fake-api/api';
import { NEW_API_BASE_URL } from 'Common/constants';

export function* loadCategories() {
  const url = `${NEW_API_BASE_URL}/authorities/categories`;
  const req = request.get(url);
  const resp = yield req;
  return resp.body;
}

export function* loadBodies(catId) {
  const url = `${NEW_API_BASE_URL}/authorities/authority-list`;
  const req = request.get(url).query({ id: catId });
  const resp = yield req;
  return resp.body;
}

export function* loadDetail(id) {
  const url = `${NEW_API_BASE_URL}/authorities/authority`;
  const req = request.get(url).query({ id });
  const resp = yield req;
  return JSON.parse(resp.body);
}

export function* search(searchTerm) {
  const url = `${NEW_API_BASE_URL}/authorities/search`;
  const req = request.get(url).query({ text: searchTerm });
  const resp = yield req;
  return resp.body;
}

export function submitApplication(formVal, errorCb) {
  const url = `${NEW_API_BASE_URL}/request/send-request`;
  const req = request.post(url).send(formVal).on('error', errorCb);
  return req;
}

export const getApi = () => {
  if (process.env.NODE_ENV === 'production') {
    return {
      loadCategories,
      loadBodies,
      loadDetail,
      search,
      submitApplication,
    };
  } else {
    return fakeApi;
  }
};

export const Api = getApi();

export default getApi;



// WEBPACK FOOTER //
// ./src/apps/authorities/api.js